module.exports = __webpack_public_path__ + "img/icn-14.52590139.svg";